export const pageAccessList = [
    { key: 'dashboard', label: 'Dashboard', type: 'page' },
    { key: 'customers', label: 'Customers', type: 'page' },
    { key: 'manage-customers', label: 'Manage Customers(Edit, Delete)', type: 'component' },
    { key: 'users', label: 'Users', type: 'page' },
    { key: 'manage-users', label: 'Manage Users(Edit, Delete)', type: 'component' },
    { key: 'rates', label: 'Rates', type: 'page' },
    { key: 'add-rates', label: 'Add Rates', type: 'component' },
    { key: 'manage-rates', label: 'Manage Rates', type: 'component' },
    { key: 'inventory', label: 'Inventory', type: 'page' },
    { key: 'manage-inventory', label: 'Manage Inventory', type: 'component' },
    { key: 'orders', label: 'Orders', type: 'page' },
    { key: 'add-order', label: 'Add Order', type: 'component' },
    { key: 'ship-order', label: 'Ship Order', type: 'component' },
    { key: 'revert-order', label: 'Revert Order', type: 'component' },
    { key: 'approve-order', label: 'Approve Order', type: 'component' },
    { key: 'manage-order', label: 'Manage Order', type: 'component' },
    { key: 'purchase-order', label: 'Purchase Order', type: 'page' },
    { key: 'add-purchase-order', label: 'Add Purchase Order', type: 'component' },
    { key: 'edit-purchase-order', label: 'Edit Purchase Order', type: 'component' },
    { key: 'packing-list', label: 'Packing List', type: 'page' },
    { key: 'add-packing-list', label: 'Add Packing List', type: 'component' },
    { key: 'edit-packing-list', label: 'Edit Packing List', type: 'component' },
    { key: 'purchase-expenses', label: 'Purchase Expenses', type: 'page' },
    { key: 'manage-purchase-expenses', label: 'Manage Purchase Expenses', type: 'component' },
    { key: 'reports', label: 'Reports', type: 'page' },
    { key: 'access', label: 'Access Control', type: 'page' },
    
    
    
  ];
